import { useLesson } from '../lessons';
import { usePlaylist } from '../savedItems';
// XAVI TODO: Fix cyclic dependency properly
import { useShort } from '../shortContent/shortContentQueries';
import { useTrack } from '../tracks';
export const useSocialShareData = ({
  lessonId,
  trackId,
  playlistId,
  shortId,
  language
}) => {
  const {
    track,
    trackLoading
  } = useTrack(trackId, language, !trackId);
  const {
    lesson,
    lessonLoading
  } = useLesson(lessonId, language, !lessonId);
  const {
    playlist,
    playlistLoading
  } = usePlaylist(playlistId, !playlistId);
  const {
    short,
    shortLoading
  } = useShort(shortId, language, !shortId || !language);
  let template = null;
  if (track) template = track.name;
  if (lesson) template = lesson.name;
  if (playlist) template = playlist.name;
  if (short) template = short.name;
  const isLoading = trackLoading || lessonLoading || playlistLoading || shortLoading;
  return {
    template,
    isLoading
  };
};